import { Component, OnInit, ChangeDetectorRef, AfterViewInit } from '@angular/core';
import { ShoppingService } from '../../core/services/shopping.service';
import { HelperService } from '../../core/services/helper.service';
import { Observable } from 'rxjs/Observable';
import { Subscription } from 'rxjs/Subscription';
import { environment } from '../../../environments/environment';
import { ApplicationListModel, UserModel } from '../../core/models/ShoppingCart.model';
import { appVariables } from '../../core/constants/Common.constant';
import { Router, ActivatedRoute } from '@angular/router';
import { LoginComponent } from '../../shoppingcart/login/login.component';

declare let $: any;
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit, AfterViewInit {
  PageTitle: string;
  APPID: string;
  logopath: string;
  ApplicationObj = new ApplicationListModel();
  ApplicationList = Array(new ApplicationListModel());
  user: UserModel;
  userDetails: UserModel;
  AppUrl: string;
  backcolor: string;
  checkcolor: string;
  useraccountid: number;
  IsCartComponent: boolean;
  IsCheckoutComponent: boolean;
  IsOrderCompleteComponent: boolean;
  IsOrderDetailComponent: boolean;
  IsLTICall : boolean;
  // LogInHeader: boolean;
  RedirectionUrl: string;
  OrderNumber: string;
  userFullName: string;
  userType: string;
  
  constructor(private activatedRoute: ActivatedRoute,
    private router: Router, private shoppingService: ShoppingService, private helperservice: HelperService) {
  }
  ngAfterViewInit() {
    $(document).ready(function () {

      $('.dropdown-toggle').click(function () {
        // debugger;
        const t = $(this).parents('.button-dropdown').children('.dropdown-menu').is(':hidden');
        $('.button-dropdown .dropdown-menu').hide();
        $('.button-dropdown .dropdown-toggle').removeClass('active');
        if (t) {
          $(this).parents('.button-dropdown').children('.dropdown-menu').toggle()
            .parents('.button-dropdown').children('.dropdown-toggle').addClass('active');
          return false;
        }
      });

      $('body').click(function () {
        //  debugger;
        const t = $(this).parents('.button-dropdown').children('.dropdown-menu').is(':hidden');
        if (!t) {
          $('.button-dropdown .dropdown-menu').hide();
          $('.button-dropdown .dropdown-toggle').removeClass('active');
        }
      });
    });
  }
  ngOnInit() {

    this.shoppingService.AutoLogOut.subscribe(isValid => {
      this.OnLogOut();
    });

    this.IsLTICall=false;
    
    this.shoppingService.observeIsLTI.subscribe(IsLTICall => {
      this.IsLTICall = IsLTICall;
    });

    this.shoppingService.IsLoggedIn.subscribe(isValid => {
      this.userDetails = this.helperservice.getUserFromLocalStorage();
      this.useraccountid = (this.userDetails.AccountID === null) ? (this.useraccountid === 0 ? 0 : (this.IsCheckoutComponent === true ? 0 : this.useraccountid)) : this.userDetails.AccountID;
      this.userFullName = (this.userDetails.FirstName + ' ' + this.userDetails.LastName).substr(0, 25);
      this.userType = this.userDetails.Role;
    });

    this.shoppingService.LoggedInDetails.subscribe(data => {
      this.userDetails = data;
      this.useraccountid = (this.userDetails.AccountID === null) ? (this.useraccountid === 0 ? 0 : (this.IsCheckoutComponent === true ? 0 : this.useraccountid)) : this.userDetails.AccountID;
      this.userFullName = (this.userDetails.FirstName + ' ' + this.userDetails.LastName).substr(0, 25);
      this.userType = this.userDetails.Role;
    });

    this.IsCartComponent = false;
    this.shoppingService.IsCartComponent.subscribe(isValid => {
      this.IsCartComponent = isValid;
    });
    this.IsCheckoutComponent = false;
    this.shoppingService.IsCheckoutComponent.subscribe(isValid => {
      this.IsCheckoutComponent = isValid;
    });

    this.IsOrderCompleteComponent = false;
    this.shoppingService.IsOrderCompleteComponent.subscribe(isValid => {
      this.IsOrderCompleteComponent = isValid;
    });
    this.IsOrderDetailComponent = false;
    this.shoppingService.IsOrderDetailComponent.subscribe(isValid => {
      this.IsOrderDetailComponent = isValid;
    });


    this.shoppingService.IsAppIDChanged.subscribe(isValid => {
      this.APPID = '5'; //FAD-219 Change
      this.logopath = environment.appConfig[this.APPID].logoImagePath;
      this.backcolor = environment.appConfig[this.APPID].color;
      this.checkcolor = environment.appConfig[this.APPID].checkcolor;

      if (this.ApplicationList.length > 0) {
        const appid = (!this.APPID) ? 5 : this.APPID;

        this.ApplicationObj = this.ApplicationList.find(function (obj) { return obj.AppID === Number(appid); });
        if (this.ApplicationObj) {
          this.updateDavisAdvatangeTokenUrl();
          this.AppUrl = this.ApplicationObj.AppURL;
          this.shoppingService.BackToPageUrl.next(this.AppUrl);
        }
      }

    });
    this.router.events.subscribe(event => {
      this.getPageTitle();
    });
    this.getPageTitle();
    this.userDetails = this.helperservice.getUserFromLocalStorage();
    this.shoppingService.observeUserDetails.subscribe(userdetails => {
      this.user = userdetails;
    });



    this.APPID = '5'; // FAD-219 Change
    this.logopath = environment.appConfig[this.APPID].logoImagePath;
    this.backcolor = environment.appConfig[this.APPID].color;
    this.checkcolor = environment.appConfig[this.APPID].checkcolor;

    if(this.IsLTICall != undefined && this.IsLTICall == false){
    this.shoppingService.observApplicationList.subscribe(applicationDetails => {
      this.ApplicationList = applicationDetails;
      if (this.ApplicationList.length > 0) {
        const appid = (!this.APPID) ? 5 : this.APPID;
        this.ApplicationObj = this.ApplicationList.find(function (obj) { return obj.AppID === Number(appid); });
        if (this.ApplicationObj) {
         this.updateDavisAdvatangeTokenUrl();
          this.AppUrl = this.ApplicationObj.AppURL;
          this.shoppingService.BackToPageUrl.next(this.AppUrl);
        }
      }
    });
  }
  
  }
  updateDavisAdvatangeTokenUrl() {
    let token = (this.helperservice.getFromLocalStorage(appVariables.accessTokenLocalStorage)) ? this.helperservice.getFromLocalStorage(appVariables.accessTokenLocalStorage) : ``;
    this.ApplicationList.find(x => x.AppID == 11).AppURL = (token) ? `${environment.davisadvantageLoginUrl}?token=${token}` : environment.AdvantageHomeurl;
  }

  fnMyAccount() {
    let accountId = this.useraccountid.toString();
    let appId = this.helperservice.getFromLocalStorage(appVariables.accessAppID);
    let url = `${environment.FADHomeUrl}universalprofile/account/getmyprofile?accountid=${accountId}&appid=${appId}`;
    window.open(url, "_self");
  }


  private getPageTitle() {
    if (this.router.url && this.router.url.toLocaleLowerCase().includes('/ShoppingCart/GetShoppingCart'.toLocaleLowerCase())) {
      this.PageTitle = 'Shopping Cart';
    } else if (this.router.url && this.router.url.toLocaleLowerCase().includes('/ShoppingCart/checkout'.toLocaleLowerCase())) {
      this.PageTitle = 'Checkout';
    } else if (this.router.url && this.router.url.toLocaleLowerCase().includes('/ShoppingCart/ordercomplete'.toLocaleLowerCase())) {
      this.PageTitle = 'THANK YOU FOR YOUR ORDER!';
    } else if (this.router.url && this.router.url.toLocaleLowerCase().includes('/ShoppingCart/OrderDetail'.toLocaleLowerCase())) {
      this.PageTitle = 'ORDER DETAILS   Order Number:';
      this.shoppingService.observeWebOrderNumber.subscribe(OrderNumber => {
        this.OrderNumber = OrderNumber;
      });
    }

  }

  OnBackToSite() {
    this.helperservice.backToSite(this.AppUrl);
  }


  fnMyProducts() {
    window.open(environment.SSOProducts, '_self');
  }

  fnHelp() {
    window.open(environment.SSOHelp, '_blank');
  }



  OnLogOut() {
    const AppID = this.helperservice.getFromLocalStorage(appVariables.accessAppID);
    document.cookie = environment.CookieName + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC;domain=.fadavis.com; path=/;';
    this.shoppingService.logOut()
      .subscribe(
        (response) => {

        },
        (error) => { }
      );
    this.helperservice.signOutUser();
    this.shoppingService.setUserDetails(new UserModel());
    this.shoppingService.setToken('');
    this.shoppingService.setAppID(AppID);
    this.shoppingService.setCartItems([]);
    this.shoppingService.setDisplaySection('LogOut');
    this.shoppingService.GetApplicationDetails();
    this.helperservice.setToLocalStorage(appVariables.accessAppID, AppID);
    this.helperservice.setToLocalStorage(appVariables.IsUserActive, 'false');

    this.shoppingService.IsLoggedIn.emit(true);
    if ((this.IsCartComponent == true || this.IsOrderCompleteComponent == true) && this.IsCheckoutComponent == false) {

      // if (this.IsCheckoutComponent === true) {
      //   this.router.navigate(['/ShoppingCart/checkout']);
      // }
      // else {
      if (this.APPID === '1') {
        this.RedirectionUrl = environment.MLLHomeUrl;
      }
      if (this.APPID === '2') {
        this.RedirectionUrl = environment.DPHomeurl;
      }
      if (this.APPID === '3') {
        this.RedirectionUrl = environment.CDOHomeurl;
      }
      if (this.APPID === '4') {
        this.RedirectionUrl = environment.DEHomeurl;
      }
      if (this.APPID === '5') {
        this.RedirectionUrl = environment.FADBaseUrl;
      }
      if (this.APPID === '7') {
        this.RedirectionUrl = environment.KIAHomeurl;
      }
      if (this.APPID === '8') {
        this.RedirectionUrl = environment.DentalHomeurl;
      }
      if (this.APPID === '9') {
        this.RedirectionUrl = environment.FitnessHomeurl;
      }
      if (this.APPID === '10') {
        this.RedirectionUrl = environment.MCLHomeurl;
      }
      if (this.APPID === '11') {
        this.RedirectionUrl = environment.AdvantageHomeurl;
      }
      if (this.APPID === '13') {
        this.RedirectionUrl = environment.DC360Url;
      }

      window.open(this.RedirectionUrl, '_self');
      // window.location.href= (this.APPID === '1') ?'https://uatmedlabsecure.fadavis.com/Home/Main' : '';
    }
    //this.shoppingService.IsLoggedIn.emit(true);
    //   }
    else {
      this.shoppingService.IsLoggedIn.emit(true);
      this.router.navigate(['/ShoppingCart/checkout']);
    }
  }



  OnClickLogin() {
    if (this.IsCartComponent === true && this.IsCheckoutComponent === false) {
      this.router.navigate(['/ShoppingCart/checkout']);
    } else {
      this.shoppingService.LogInHeader.emit(true);
    }

    // this.router.navigate(['/ShoppingCart/checkout']);
  }
  toggled(event) {
    if (event) {
      document.getElementById("mobile-menu-dropdown").classList.remove("dropdown-close");
    } else {
      document.getElementById("mobile-menu-dropdown").classList.add("dropdown-close");
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/layout/header/header.component.ts